import { actionTypes } from './actions';
import initialState from './initialState';

export default function (state = initialState, action) {
  switch (action.type) {
    case actionTypes.SET:
      return action.payload;
    case actionTypes.RESET:
      return initialState;
    default:
      return state;
  }
}
